import { FeatureType } from '@project-gd-x/dating-site-contracts/src/gen/gdx/market/v1/package_pb';

import ChatRequestPromoModal from '@/components/chat-request-promo-modal/ChatRequestPromoModal.vue';
import MatchModal from '@/components/match-modal/MatchModal.vue';
import { warehouseApi } from '@/services/api/warehouse/warehouse-api';
import { isModalVisible, useModal } from '@/services/modal/modal';
import {
  addNotificationHandler,
  NotificationHandler,
  removeNotificationHandler,
} from '@/services/websocket';
import { dispatch } from '@/store/store-helper';

let modal: { showModal: any; hideModal: any } | null = null;

const DELAY_MS = 1500;
const LIKE_COUNT_KEY = 'r2r_like_count';
const LIKE_COUNT_LIMIT = 1;

type ShowArg = {
  userId: string;
};
function show(arg: ShowArg) {
  modal = useModal(() => ({
    component: ChatRequestPromoModal,
    props: {
      userId: arg.userId,
    },
  }));
  modal.showModal();

  // Make popup unavailable.
  setLikeCount(LIKE_COUNT_LIMIT);
}

let delayId: number | null = null;
// Delay needed to wait `match` socket, if it arrives before modal is shown -- do not show modal.
function showWithDelay(arg: ShowArg, delayMs = DELAY_MS) {
  if (delayId !== null || isModalVisible(MatchModal)) {
    return;
  }

  addNotificationHandler(handleWebsocket);

  delayId = window.setTimeout(() => {
    show(arg);
    clearDelay();
  }, delayMs);
}

function clearDelay() {
  if (delayId !== null) {
    clearTimeout(delayId);
    delayId = null;
  }
}

function hide() {
  if (modal) {
    modal.hideModal();
    modal = null;
  }
}

async function getLikeCount() {
  const likeCountResp = await warehouseApi.get([LIKE_COUNT_KEY]);
  return +(likeCountResp.items[LIKE_COUNT_KEY] ?? 0);
}

async function setLikeCount(likeCount: number) {
  await warehouseApi.save({
    [LIKE_COUNT_KEY]: {
      value: likeCount.toString(),
    },
  });
}

async function getIsAvailable(userId: string) {
  const likeCount = await getLikeCount();
  if (likeCount >= LIKE_COUNT_LIMIT) {
    return false;
  }

  const connectionMap = await dispatch('actionProfileGetConnectionState', userId);

  const featureMap = await dispatch('actionCommonGetFreeCreditsFeaturesStatus');

  // If we have at least 1 power like and user do not have chat request yet.
  return Number(featureMap[FeatureType.POWER_LIKE]) > 0 && !connectionMap[userId].isPowerLiked;
}

const handleWebsocket: NotificationHandler = async (notification) => {
  if (notification.notification.case === 'matchFromMe') {
    const matchFromMe = notification.notification.value;

    if (matchFromMe) {
      clearDelay();
      removeNotificationHandler(handleWebsocket);
    }
  }
};

export const chatRequestPromoModal = {
  show,
  showWithDelay,
  hide,
  getIsAvailable,
  handleWebsocket,
};
